module.exports = __webpack_public_path__ + "img/slb.aa819297.svg";